import script from "./post.vue?vue&type=script&lang=ts&setup=true"
export * from "./post.vue?vue&type=script&lang=ts&setup=true"

import "./post.vue?vue&type=style&index=0&id=7549759b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7549759b"]])

export default __exports__